import BlockedAccounts from './BlockedAccounts';

export default BlockedAccounts;
